import React, { ChangeEvent, useCallback, useState } from 'react';
import { FiUpload } from 'react-icons/fi';
import { useHistory, useLocation } from 'react-router-dom';

import api from '../../services/api';

import { useToast } from '../../hooks/toast';

import Button from '../../components/Button';

import { Content, UploadMultimediaInput } from './styles';
import StandardContainer from '../../components/StandardContainer';
import Header from '../../components/Header';

interface LocationState {
  id: string;
};

const MultimediaUpload = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const { state } = useLocation<LocationState>();

  const [file, setFile] = useState<File>();
  const [loading, setLoading] = useState(false);
  const [imgSize, setImgSize] = useState({ height: 0, width: 0 });

  const handleImageChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        const file = e.target.files[0];

        const img = new Image()
        var _URL = window.URL || window.webkitURL;

        var objectUrl = _URL.createObjectURL(file);
        img.src = objectUrl;

        img.onload = () => {
          const { height, width } = img

          console.log({ height, width })
          setImgSize({ height, width })

        }


        setFile(file)
      }
    },
    [setFile,setImgSize],
  );

  const handleUploadImage = useCallback(async () => {
    setLoading(true);
    try {
      if (file) {
        const data = new FormData();
        data.append('stream_multimedia', file);

        await api.patch(`/stream_multimedia/${state.id}/icon`, data);
        history.push('/multimedia');

        addToast({
          type: 'success',
          title: 'Imagem da transmissão atualizada!',
        });
      }
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Erro ao atualizar imagem!',
        description: 'Tente novamente mais tarde :)',
      });
    }

    setLoading(false);
  }, [addToast, file, history, state.id,imgSize]);

  return (
    <StandardContainer>
      <Header />
      <Content>
        <h1>Adicionar imagem da transmissão ao vivo</h1>

        <UploadMultimediaInput>
          <input disabled value={file?.name} />
          <label htmlFor="uploadMultimedia">
            <FiUpload />
            <input type="file" id="uploadMultimedia" onChange={handleImageChange} />
          </label>
        </UploadMultimediaInput>
        {imgSize.width > 0 && imgSize.height > 0 && (
            <span>
              {imgSize.width} x {imgSize.height}
            </span>
          )}
        <Button onClick={handleUploadImage} loading={loading}>Salvar</Button>
      </Content>
    </StandardContainer>
  )
}

export default MultimediaUpload;
